import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataManager } from '@syncfusion/ej2-data';
import { CrawfordApiGridAdaptor } from 'crawford-shell';
import { Observable } from 'rxjs/Observable';
import { global } from '../app.settings';
import { SavedSearch } from './model/saved-search.model';
import { NamedObject } from './model/named-object.model';


@Injectable()
export class SavedSearchService {
  private savedSearch: SavedSearch;

  constructor(
    private http: HttpClient
  ) { }

  public getExistingSearchNames(): Observable<NamedObject[]> {
    return this.http.get<NamedObject[]>(global.apiUrl + 'saved-search-list/existing-search-names');
  }

  public getCurrentUserSavedSearchDataManager(adaptor: CrawfordApiGridAdaptor): DataManager {
    return new DataManager({
      url: global.apiUrl + 'saved-search-list/current-user',
      adaptor: adaptor
    });
  }

  public getAllUsersSavedSearchDataManager(adaptor: CrawfordApiGridAdaptor): DataManager {
    return new DataManager({
      url: global.apiUrl + 'saved-search-list',
      adaptor: adaptor
    });
  }

  public getSavedSearchById(id: number): Observable<SavedSearch> {
    return this.http.get<SavedSearch>(global.apiUrl + 'saved-search/' + id);
  }

  public retrieveSavedSearchById(id: number): Observable<SavedSearch> {
    return this.http.put<SavedSearch>(global.apiUrl + 'saved-search/retrieve/' + id, id);
  }

  public getSavedSearchByName(searchName: string, userName: string): Observable<SavedSearch> {
    return this.http.get<SavedSearch>(global.apiUrl + 'saved-search/searches/' + userName + '/' + searchName);
  }

  public createSavedSearch(search: SavedSearch): any {
    return this.http.post(global.apiUrl + 'saved-search', search);
  }

  public updateSavedSearch(search: SavedSearch, id: number): any {
    return this.http.put(global.apiUrl + 'saved-search/' + id, search);
  }

  public deleteSavedSearch(id: number): any {
    return this.http.delete(global.apiUrl + 'saved-search/' + id);
  }

  public getSavedSearchUsersList(): Observable<string[]> {
    return this.http.get<string[]>(global.apiUrl + 'saved-search-list/users');
  }

  public setRetrievedSearch(retrievedSearch: SavedSearch) {
    this.savedSearch = retrievedSearch;
  }

  public getRetrievedSearch(): any {
    return this.savedSearch;
  }

  public resetRetrievedSearch(searchId: number): void {
    if (!searchId || (this.savedSearch && this.savedSearch.id === searchId)) {
      this.savedSearch = null;
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/saved-search/saved-search.service.ts